"use client";

import { useState } from "react";
import Image, { StaticImageData } from "next/image";
import { Smoothup } from "@/components/common/animations/Smoothup";
import PressCopyBlock from "./PressCopyBlock";

interface PressFounderSectionProps {
  name: string;
  title: string;
  image: StaticImageData;
  shortBio: string;
  longBio: string;
  linkedin: string;
  x: string;
}

export default function PressFounderSection({
  name,
  title,
  image,
  shortBio,
  longBio,
  linkedin,
  x,
}: PressFounderSectionProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-5 xl:px-0">
        <Smoothup>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10">
            Founder
          </h2>
        </Smoothup>

        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
          <Smoothup className="shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden bg-gray-100">
              <Image
                src={image}
                alt={name}
                width={192}
                height={192}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="mt-4">
              <h3 className="text-xl font-bold text-gray-900">{name}</h3>
              <p className="text-sm text-gray-500">{title}</p>
              <div className="flex gap-3 mt-3">
                <a
                  href={linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs font-medium text-cyan-600 hover:text-cyan-700 transition-colors"
                >
                  LinkedIn
                </a>
                <a
                  href={x}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs font-medium text-cyan-600 hover:text-cyan-700 transition-colors"
                >
                  X
                </a>
              </div>
            </div>
          </Smoothup>

          <div className="flex-1 space-y-6">
            <Smoothup delay={0.05}>
              <PressCopyBlock text={shortBio} label="Short Bio" />
            </Smoothup>

            <Smoothup delay={0.1}>
              <button
                onClick={() => setExpanded(!expanded)}
                className="text-sm font-medium text-cyan-600 hover:text-cyan-700 transition-colors"
              >
                {expanded ? "Hide full bio" : "Show full bio"}
              </button>
              {expanded && (
                <div className="mt-4">
                  <PressCopyBlock text={longBio} label="Full Bio" />
                </div>
              )}
            </Smoothup>
          </div>
        </div>
      </div>
    </section>
  );
}
